// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";

let extendedIcons = new Set(__ORCA_EXTENDED_ICONS__);

function spriteFor(iconType, name) {
  if (iconType === "orca" && extendedIcons.has(name)) {
    return "orca-extended";
  } else {
    return iconType;
  }
}

function Icon(props) {
  let __shouldMirrorIcon = props.shouldMirrorIcon;
  let __style = props.style;
  let __iconType = props.iconType;
  let className = props.className;
  let __width = props.width;
  let __size = props.size;
  let name = props.name;
  let __size_value = __size !== undefined ? __size : 20;
  let __width_value = __width !== undefined ? __width : __size_value;
  let __iconType_value = __iconType !== undefined ? __iconType : "orca";
  let __style_value = __style !== undefined ? __style : ({});
  let __shouldMirrorIcon_value = __shouldMirrorIcon !== undefined ? __shouldMirrorIcon : false;
  let otherClasses = className !== undefined ? className : "";
  return JsxRuntime.jsx("svg", {
    children: JsxRuntime.jsx("use", {
      xlinkHref: __SDK_CONFIG__.publicPath + `/icons/` + spriteFor(__iconType_value, name) + `.svg#` + name
    }),
    className: `fill-current ` + otherClasses,
    style: __style_value,
    height: __size_value.toString() + "px",
    width: __width_value.toString() + "px",
    onClick: props.onClick,
    transform: __shouldMirrorIcon_value ? "scale(-1,1)" : ""
  });
}

let make = Icon;

export {
  extendedIcons,
  spriteFor,
  make,
}
/* extendedIcons Not a pure module */
